export default "__VITE_ASSET__91da19de__"